const style = {
  container: {
    width: "100%",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#181a20",
    color: "#FFF",
    padding: "30px",
    boxSizing: "border-box",
  },
  card: {
    background: "#1e212b",
    borderRadius: "12px",
    padding: "40px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "25px",
    border: "1px solid #2a2f3b",
    width: "100%",
    maxWidth: "500px",
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.2)",
  },
  title: {
    fontSize: "28px",
    fontWeight: "600",
    margin: 0,
    color: "#FFF",
  },
  description: {
    fontSize: "15px",
    color: "#aeb9c4",
    textAlign: "center",
    lineHeight: 1.6,
    margin: "0 0 10px 0",
  },
  inputGroup: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  label: {
    fontSize: "14px",
    color: "#aeb9c4",
    marginBottom: "10px",
    alignSelf: "flex-start",
  },
  input: {
    width: "100%",
    height: "50px",
    background: "#2a2f3b",
    border: "1px solid #3c4257",
    borderRadius: "12px",
    padding: "0 20px",
    boxSizing: "border-box",
    color: "#FFF",
    fontSize: "18px",
    outline: "none",
    textAlign: "center",
  },
  errorText: {
    color: "#ff5b5b",
    fontSize: "13px",
    marginTop: "10px",
    height: "15px",
  },
  totalContainer: {
    width: "100%",
    display: "flex",
    boxSizing: "border-box",
    justifyContent: "space-between",
    alignItems: "center",
    background: "#2a2f3b",
    padding: "20px",
    borderRadius: "12px",
    marginTop: "10px",
  },
  totalLabel: {
    fontSize: "16px",
    color: "#aeb9c4",
    fontWeight: "500",
  },
  totalValue: {
    fontSize: "26px",
    fontWeight: "700",
    color: "#4ecf78",
  },
  payButton: {
    width: "100%",
    height: "50px",
    background: "#4ecf78",
    color: "#1e212b",
    border: "none",
    borderRadius: "12px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    marginTop: "15px",
    transition: "background-color 0.2s ease",
  },
  disabledButton: {
    background: "#3c4257",
    cursor: "not-allowed",
    opacity: 0.6,
  },
};

export default style;
